import { render, staticRenderFns } from "./input-dynamic-tree-select.vue?vue&type=template&id=2d664fbd&scoped=true"
import script from "./input-dynamic-tree-select.ts?vue&type=script&lang=ts&external"
export * from "./input-dynamic-tree-select.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d664fbd",
  null
  
)

export default component.exports